import { fromJS, OrderedMap, List, Seq } from 'immutable';
import { errorlog } from '../helpers/ErrorLogService';

const initialState = fromJSOrdered({
  "SEARCH": {},
  "ACTIONSEARCH": {
    "total": "",
    "items": OrderedMap()
  },
  "autoSearch":"",
  "defaultActionCat":"",
  "libFailedType" : '',
  'PREBUILT': {
    "total": "",
    "data": OrderedMap()
  },
  'PREBUILTSCENES': {
    'total': '',
    'data' : OrderedMap()
  },
  'PROP': {
    "total": "",
    "data": OrderedMap()
  },
  'EPROP': {
    "total": "",
    "data": OrderedMap()
  },
  'ECHR': {
    "total": "",
    "data": OrderedMap()
  },
  'GIPHY': {
    "total": "",
    "data": OrderedMap()
  },
  'TEXT': {
    "total": "",
    "data": OrderedMap()
  },
  'SHAPE': {
    "total": "",
    "items": OrderedMap()
  },
  'TXTGRP': {
    "total": "",
    "items": OrderedMap()
  },
  'TXTOVLY': {
    "total": "",
    "items": OrderedMap()
  },
  'BG': {
    "total": "",
    "data": OrderedMap()
  },
  'IMG': {
    "total": "",
    "items": OrderedMap()
  },
  'STOCKIMG': {
    "total": "",
    "data": OrderedMap()
  },
  'VIDEO': {
    "total": "",
    "items": OrderedMap()
  },
  'STOCKVID': {
    "total": "",
    "data": OrderedMap()
  },
  'CCHR': {
    "total": "",
    "items": OrderedMap()
  },
  'CHR': {
    "total": "",
    "data": OrderedMap()
  },
  'UPIMAGE':{
    "data" : OrderedMap(),
    "total" : 0
  },
  'UPVIDEO':{
    "data" : OrderedMap(),
    "total" : 0
  },
  'EFFECTS': {
    'ENTER': List(),
   
  },
  'UPLOADS': {
    "items": OrderedMap()
  },
  'ACTION': {
    "total": "",
    "items": OrderedMap()
  },
  'SM': {
    "total": "",
    "data": OrderedMap()
  },
  'TRANS':{},
  'uploadedFile' : '',
  'versions':{}
});

function fromJSOrdered(js) {
  return typeof js !== 'object' || js === null ? js :
    Array.isArray(js) ?
      Seq(js).map(fromJSOrdered).toList() :
      Seq(js).map(fromJSOrdered).toOrderedMap();
}

function getRandomColor() {
  var letters = '0123456789ABCDEF';
  var color = '#';
  for (var i = 0; i < 6; i++) {
    color += letters[Math.floor(Math.random() * 16)];
  }
  return color;
}

export default function animakerStore(state = initialState, action) {
  var uploadItems = fromJS({});
  switch (action.type) {

    case "CREATE_FOLDER_COMPLETE":
      var obj = { "active": 1, "userid": 1, "roottype": "folder", "created": action.data.response.created, "name": action.data.response.name, "parent": action.data.response.parent }
      state = state.setIn(["UPLOADS", "items", action.data.response.id], fromJS(obj));
      return state;

    case "RENAME_USER_FILE":
      state = state.setIn(["UPLOADS", "items", action.libData.id, "name"], action.libData.name);
      return state;

    case "MOVE_FILE_LOCATION":
      for (var i = 0; i < action.libData.id.length; i++) {
        state = state.updateIn(["UPLOADS", "items"], value => value.delete(action.libData.id[i]));
      }
      return state;

    case "DELETE_FILE":
    
      if(typeof action.id === 'object'){
        action.id.map((fileId) => {
          state = state.updateIn(["UPLOADS", "items"], value => value.delete(fileId));
        })
        return state;
      }else{
        return state.updateIn(["UPLOADS", "items"], value => value.delete(action.id));
      }
      
    case "UPLOADED_FILE":
        state = state.set('uploadedFile', action.data);
        return state;

    case "SET_SEARCH_DATA":
      state = state.set("SEARCH", fromJS(action.data));
      return state;

    case "LOAD_ACTIONS":
      state = state.setIn(["ACTION", "total"], action.total);
      if(!state.getIn(["ACTION", "items"]).size || action.data.get(action.data.keys().next().value).genderType !== state.getIn(["ACTION", "items"]).first().get('genderType'))
        state = state.setIn(["ACTION", "items"], OrderedMap());
      action.data.forEach((value, key) => {
        state = state.setIn(["ACTION", "items", key], fromJS(value));
      });
      return state;

      case 'FETCH_ACTION_SEARCH':
      if (!action.libData.fromScroll)
      {
        state = state.setIn(["ACTIONSEARCH", "total"], action.total);
        state = state.setIn(["ACTIONSEARCH", "items"], OrderedMap())

      }
      return state;

      case "LOAD_AUTOSEARCH":
        state = state.setIn(["autoSearch"], fromJS(action.data["ACTION"]))
        state = state.setIn(["defaultActionCat"], fromJS(action.data["ACTIONCATEGORY"]))
        
      return state;

      case "LOAD_ACTIONSEARCH_DATA":
      state = state.setIn(["ACTIONSEARCH", "total"], action.total);
      action.data.forEach((value, key) => {
        state = state.setIn(["ACTIONSEARCH", "items", key], fromJS(value));
      });

      return state

    case 'CLEAR_ACTIONS':
        state = state.setIn(["ACTION", "items"], OrderedMap());
        return state;

    case 'LOAD_MASTER_LIBRARY_COMPLETE':
      switch (action.libType) {
        case "HPRE":
        case "VPRE":
        case "SPRE":
          state = state.setIn(['PREBUILT'], OrderedMap());
          state = state.setIn(['PREBUILT'], fromJSOrdered(action.data));
          return state;
        case 'PROP':
        case 'BG':
          state = state.setIn([action.libType], OrderedMap());
          state = state.setIn([action.libType], fromJSOrdered(action.data));
        return state;
        case 'UPIMAGE':
        case 'UPVIDEO':
            let dataExist = state.getIn([action.libType,'data']);
            if(dataExist.size){
              try{
                action.data.data.forEach(val => {
                  let isExist = false;
                  for(let i=0; i<dataExist.size; i++){
                    if(dataExist.get(i).get('id') === val.id){
                      isExist = true;
                      break;
                    }
                  }
                  if(!isExist)
                      state = state.updateIn([action.libType, 'data'], arr => {
                        return arr.concat(fromJSOrdered([val]))
                      });
                })
              }catch(err){
                errorlog('Error in libData ',err, "libraryReducer-animakerStore");
              }
              
            }else{
              state = state.setIn([action.libType], fromJSOrdered({
                data : action.data.data,
                total : action.data.total
              }));
            }
            
          return state;
        default:
          return state
      }
    
    case 'FETCH_SEARCH':
      if (!action.libData.fromScroll)
        state = state.set("SEARCH", fromJS({}));
      return state;
    
    case 'LOAD_SEARCH_DATA':
      if (!action.fromScroll){
        if(action.aggs){
          fromJS(action.aggs).entrySeq().forEach(([key, value]) => {
            let keyTab = value.get('key').toUpperCase();
            state = state.setIn(["SEARCH", keyTab, "total"], value.get('doc_count'));
            state = state.setIn(["SEARCH", keyTab, "items"], OrderedMap());
          })
        }
      }
      action.data.forEach((datas) => {
        let dataToItr = new OrderedMap(datas.data);
        dataToItr.entrySeq().forEach(([key, value]) => {
          state = state.setIn(["SEARCH", datas.type, "items", key], fromJS(value));
          state = state.setIn(['SEARCH', datas.type, 'loadedType'], action.libType);
          state = state.setIn(['SEARCH', datas.type, 'loadedValue'], action.tagValue);
        });
      })
      
      return state

    case 'CLEAR_PROP_CACHE':
    state = state.set(state.getIn(['PROP', 'total']), 0);
    state = state.set(state.getIn(['PROP', 'data']), OrderedMap({}));
    return state


    case 'CLEAR_DATA_CACHE':
      if(action.data.category){
        if(state.getIn([action.data.type, 'data', action.data.category, 'items']).size > action.data.max){
          let count = 0;
          state.getIn([action.data.type, 'data', action.data.category, 'items']).entrySeq().forEach(([key, val]) => {
            count++;
            if(count > action.data.max)
              state = state.setIn([action.data.type, 'data', action.data.category, 'items'], state.getIn([action.data.type, 'data', action.data.category, 'items']).delete(key))
          })
        }
      }else{
        let maxCount = 5;
        if(state.getIn([action.data.type, 'data']).has('Top Exclusive')){
          maxCount = 6;
        }
        let mainCount = 0;
        state.getIn([action.data.type, 'data']).entrySeq().forEach(([key, value]) => {
          mainCount++;
          if(mainCount > maxCount){
            state = state.setIn([action.data.type, 'data'], state.getIn([action.data.type, 'data']).delete(key))
          }else{
            if(key !== 'All Items'){
              let count = 0;
              value.get('items').entrySeq().forEach(([k, val]) => {
                count++;
                if(count > action.data.max)
                  state = state.setIn([action.data.type, 'data', key, 'items'], state.getIn([action.data.type, 'data', key, 'items']).delete(k))
              })
            }
          }
        })
      }
      
      
    return state

    case 'RESP_UPDATE':
      state = state.set('libFailedType', action.data.status);
    return state;

    case 'LOAD_CATEGORY_COMPLETE':
      
      
      switch (action.libData.type) {
        case "HPRE":
        case "VPRE":
        case "SPRE":
          state = state.setIn(['PREBUILT', action.libData.categories, "total"], action.total);
          fromJS(action.data).entrySeq().forEach(([key, value]) => {
            state = state.setIn(['PREBUILT', action.libData.categories, "items", key], fromJS(value));
          });
          return state
        case 'PROP':
        case 'BG':
        case 'TEXT':
        case 'GIPHY':
        case 'PREBUILT':
        case 'STOCKVID':
        case 'SM':
        case 'CHR':
        case "STOCKIMG":
        if(action.libData.type === 'PROP' || action.libData.type === 'BG' || action.libData.type === 'STOCKIMG' || action.libData.type === 'STOCKVID' || action.libData.type === 'CHR' || action.libData.type === 'PREBUILT' || action.libData.type === 'GIPHY' || action.libData.type === 'TEXT' || action.libData.type === 'SM'){
          state = state.setIn([action.libData.type, 'data', action.libData.categories, "total"], action.total);
          if(!state.getIn([action.libData.type, 'data', action.libData.categories, "items"])){
            state = state.setIn([action.libData.type, 'data', action.libData.categories, "items"], OrderedMap());
          }
          var i =0;
          let dataToItr = OrderedMap(action.data)
          dataToItr.entrySeq().forEach(([key, value]) => {

            i++;
            value.name = value[`name_${action.lang}`];
            state = state.setIn([action.libData.type, 'data', action.libData.categories, "items",key], fromJS(value));
          });
          if(action.libData.type === 'TEXT' && Object.keys(action.brandData).length){
            state = state.setIn([action.libData.type, 'data', 'brandData'], fromJS(action.brandData));
          }
        }else{
          state = state.setIn([action.libData.type, action.libData.categories, "total"], action.total);
          fromJS(action.data).entrySeq().forEach(([key, value]) => {
            state = state.setIn([action.libData.type, action.libData.categories, "items", key], fromJS(value));
          });
          
        }

          return state;

        case 'VIDEO':
        case "IMG":
        case "SHAPE":
        case "CCHR":
        case "CHR":
          state = state.setIn([action.libData.type, "total"], action.total);
          fromJS(action.data).entrySeq().forEach(([key, value]) => {
            state = state.setIn([action.libData.type, "items", key], value);
          });
          return state;

        default:
          return state
      }

    case 'ADD_UPLOAD_ITEM':
      let value = { src: action.data.src, subType: action.data.subType, width: action.data.width, type: action.data.type, height: action.data.height };
      if (action.data.type !== "IMG")
        value['duration'] = action.data.duration;
      if (action.data.type !== "AUDIO")
        value['thumbnail'] = action.data.thumbnail;
      else if (action.data.type === "AUDIO")
        value['name'] = action.data.name;

      state = state.setIn(["UPLOADS", "items", action.data.id], fromJS(action.data));

      uploadItems = state.getIn(["UPLOADS", "items"]).sortBy((value) => value.get('created')).reverse();
      state = state.setIn(["UPLOADS", "items"], uploadItems);
      return state;

    case 'GET_PREBUILT_SCENES':
    let data = state.get('PREBUILT').get('data').get(action.data.name).get('items').get(action.data.id);
    if(action.data.fromType === 'SEARCH'){
      data = state.get(action.data.fromType).get('PREBUILT').get('items').get(action.data.id);
    }
    state = state.setIn(['PREBUILTSCENES','data','total'], data.get('scenetotal')); 

    state = state.setIn(['PREBUILTSCENES','data', 'sceneName'], data.get('name'));
    state = state.setIn(['PREBUILTSCENES','data', 'scenes'], data.get('scenes'));
    return state;
    case 'LOAD_LIBRARY_COMPLETE':
      switch (action.libType) {
        
        case "CCHR":
        case "ECHR":
          state = state.setIn([action.libType, "total"], action.total);
          let dataToItr = OrderedMap(action.data);
          state = state.setIn([action.libType, "items"], OrderedMap());
          dataToItr.entrySeq().forEach(([key, value]) => {
            value = fromJS(value);
            value = value.set('background', getRandomColor());
            state = state.setIn([action.libType, "items", key], value);
          });
          return state;

        case "IMG":
        case 'VIDEO':
        case 'SHAPE':
          state = state.setIn([action.libType, "total"], action.total);
          fromJS(action.data).entrySeq().forEach(([key, value]) => {
            state = state.setIn([action.libType, "items", key], value);
          });
          return state;

        case 'UPLOADS':
          
          state = state.setIn([action.libType, "items"], OrderedMap())
          action.data.forEach((value) => {
            state = state.setIn([action.libType, "items", value.id], fromJS(value));
          });
          return state;

        case 'PROP':
        case 'BG':
        case "STOCKIMG":
        case "STOCKVID":
        case 'ACTION':
        case 'GIPHY':
        case "PREBUILT":
        case 'SM':
        case 'CHR':
        if((action.libType === 'PROP' && action.subType !== 'EPROP') || action.libType === 'STOCKIMG' || action.libType === 'STOCKVID' || action.libType === 'CHR' || action.libType === 'BG' || action.libType === 'GIPHY' || action.libType === 'PREBUILT' || action.libType === 'SM'){
          let dataToItr = OrderedMap(action.data);
          dataToItr.entrySeq().forEach(([key, value]) => {
            if(key === 'total'){
              state = state.setIn([action.libType, key], value);
            }else{
              let datas = OrderedMap(action.data.data);
              datas.entrySeq().forEach(([key, value]) => {
                if(!state.getIn([action.libType, 'data', key, "items"])){
                  state.setIn([action.libType, 'data', key, "items"], OrderedMap());
                }
                let values = new OrderedMap(), stockVal = new OrderedMap();
                fromJS(value).get('items').forEach((val) => {
                  let keyID = val.get('id');
                  if(action.libType === 'STOCKIMG'){
                    stockVal = stockVal.set('id', keyID);
                    stockVal = stockVal.set('thumbnail', val.get('display_sizes').get(2).get('uri'));
                    stockVal = stockVal.set('src', val.get('display_sizes').get(0).get('uri')); 
                    stockVal = stockVal.set('name', val.get('title'));
                    stockVal = stockVal.set('width', val.get('max_dimensions').get('width'));
                    stockVal = stockVal.set('height', val.get('max_dimensions').get('height')); 
                    stockVal = stockVal.set('type', action.libType); 
                    stockVal = stockVal.set('artist', val.get('artist'));
                    stockVal = stockVal.set('title', val.get('title'));
                    stockVal = stockVal.set('stockId', keyID);
                    stockVal = stockVal.set('subType', val.get('subType'));
                    stockVal = stockVal.set('istock_collection', val.get('istock_collection'));
                    stockVal = stockVal.set('cost', val.get('cost'));
                    values = values.set(keyID, stockVal)
                  }else{
                    if(action.libType === 'SM'){
                      val = val.set('name', val.get(`name_${action.lang}`));
                    }
                    values = values.set(keyID, val)
                  }
                })
                state = state.setIn([action.libType, 'data', key, "searchtag"], fromJS(value).get('searchtag'));
                state = state.setIn([action.libType, 'data', key, "items"], values);
              });
            }
          })
        }else{
          let datasToItr = OrderedMap(action.data);
          if(action.subType === 'EPROP'){
            action.libType = action.subType;
            let epropVal = new OrderedMap();
            datasToItr.entrySeq().forEach(([key, value]) => {
              epropVal = epropVal.set(key, fromJS(value));
              
            });
            state = state.setIn([action.libType,'data', key, 'items'], epropVal);
          }else{
            datasToItr.entrySeq().forEach(([key, value]) => {
              state = state.setIn([action.libType, key, "searchtag"], fromJS(value).get('searchtag'));
              state = state.setIn([action.libType, key], fromJS(value));
            });
          }
        }
        state = state.set('libFailedType', 'completed');
          
          return state;

        case 'SEARCH':
          if (action.searchType === 'enter') {
            return state.setIn([action.libType], fromJS(action.data));
          } else {
            fromJS(action.data).entrySeq().forEach(([key, value]) => {
              state = state.setIn([action.libType, key], value);
            });
            return state;
          }

        case 'COLOR_THEMES':
        case 'EFFECTS':
          return state.setIn([action.libType], fromJS(action.data));
        
        case 'TRANS':
          var transData = action.data;
          for(var key in transData)
          {
            transData[key] = fromJS(transData[key])
          }
          state = state.setIn(["TRANS"], OrderedMap(transData))
          return state;

        case 'TEXT':
          state = state.setIn([action.subType, "total"], action.total);
          fromJS(action.data).entrySeq().forEach(([key, value]) => {
            state = state.setIn([action.subType, "items", key], value);
          });
        return state;

        default:
          return state
      }
      case 'VERSION_HISTORY':
        state = state.setIn(['versions'],state.getIn(['versions']).merge(fromJS(action.data)));
      return state;
    default:
      return state
  }
}



// WEBPACK FOOTER //
// ./src/reducers/library.js